
export default "/assets/question-mark-circle-micro.023cae25.svg"